module.exports = __webpack_public_path__ + "static/media/diagnoses.1e306ba8.svg";